import { forwardRef, SelectHTMLAttributes } from 'react';
import { foundationSemantic } from '../../foundation';
import { cx } from './utils';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid = false, className, children, ...props },
  ref
) {
  return (
    <select
      ref={ref}
      className={cx(
        'w-full border text-sm',
        foundationSemantic.input.base,
        foundationSemantic.input.field,
        foundationSemantic.input.surface,
        foundationSemantic.input.border,
        foundationSemantic.input.text,
        invalid && foundationSemantic.input.invalid,
        className
      )}
      aria-invalid={invalid || undefined}
      {...props}
    >
      {children}
    </select>
  );
});

export default Select;
export type { SelectProps };
